import { render, staticRenderFns } from "./HospitalLedger.vue?vue&type=template&id=378105d5"
import script from "./HospitalLedger.vue?vue&type=script&lang=js"
export * from "./HospitalLedger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports